<template>
  <div class="announcement-warp">
    <Applition v-if="link==='S01'" :props-id="link" :wd="wd" />
    <Resoure v-if="link==='S02'" :props-id="link" :wd="wd" />
    <Teacher v-if="link==='S03'" :props-id="link" :wd="wd" />
    <SchoolStyle
      v-if="link==='S14'"
      :props-id="link"
      :wd="wd"
      :props-obj="{link:'searchResultDetail'}"
    />
  </div>
</template>
<script>
import Applition from './searchResultList/applition';
import Resoure from './searchResultList/resoure';
import Teacher from './searchResultList/teacher';
import SchoolStyle from '@/views/schoolStyle/tabList'; // 学校
export default {
  name: 'SearchResult',
  components: {
    Applition,
    Resoure,
    Teacher,
    SchoolStyle
  },
  data: () => {
    return {
      link: '',
      wd: ''
    };
  },
  computed: {
  },
  watch: {
    $route: {
      handler: function(route) {
        this.link = route.params.id;
        this.wd = route.query.wd;
      },
      immediate: true
    }
  },
  mounted() {

  },
  methods: {
  }
};
</script>
